<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css' // 这个nprogress样式必须引入
export default {
  name: 'App',
  created () {
    this.$router.beforeEach((to, from, next) => {
      NProgress.start()
      next()
    })
    this.$router.afterEach(() => {
      NProgress.done()
    })
  }

}
</script>

  <style lang="stylus">
  html,body
    margin 0
    padding 0
    font-size 50px
    overflow hidden
    height 100%
    width 100%
    .modals
      width 100%
      margin-top .18rem
      margin-left .18rem
      .addmodal
        width 100%
        display flex
        form
          width 100%
          user-select none
          .formitem
            width 100%
            padding .18rem 10%
            input
              background none
              color #707070
              border 1px solid #707070
              outline none
              padding .18rem
              &::-webkit-input-placeholder
                color #a1a1a1
              &::-moz-placeholder
                color #a1a1a1
              &::-moz-placeholder
                color #a1a1a1
              &::-ms-input-placeholder
                color #a1a1a1
            select
              background none
              color #707070
              border 1px solid #707070
              outline none
              padding .18rem
            label
              color #707070
            textarea
              background none
              border  1px solid #707070
              outline none
              padding .1rem
              color #707070
              font-size .28rem
            .danger
              color #ff5555
              padding 0 .1rem
            span
              color #707070
              &:hover
                color #138ce4
                cursor pointer
          .buttons
            width 100%
            text-align left
            padding .18rem 10%
            input
              background none
              // border #cdcdcd
              color #707070
              outline none
              border 1px solid #707070
              padding  .18rem .58rem
              &:hover
                background #212529
                color white
                cursor pointer
    .toasted>.primary>.action, .toasted .toasted-primary .action
      color white
      .v-page-li-active, .urlmanager, .v-dropdown-items-li.active
        background: #212529
        border #212529
    .toasted-container.bottom-right
      bottom .18rem
      right .18rem
    .toasted-container.top-right
      top .8rem
      right 1px
    .toasted .primary.info,.toasted.toasted-primary.info
      background #212529
    .toasted-container .toasted .action
      font-size .18rem
      a
        color white
    .v-dropdown-selected:hover
      color white
    .v-page-li:hover
      border-color #212529
    .v-page-li:hover a
      color #212529
    .v-page-goto-input:hover
      border-color #212529
      outline none
    .v-checkbox-checked .v-checkbox-inner,.v-checkbox-indeterminate .v-checkbox-inner
      border-color #212529
      background-color  #212529
 </style>>



// WEBPACK FOOTER //
// src/App.vue